export default __webpack_public_path__ + "static/media/Digital Keys.b25e8e66.svg";